/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-08 17:10:50
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-19 10:09:31
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  TimePicker,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectEdition } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { PayMethod } from '../../../../models/payment'
import { Checks, Settinglable, Settings } from '../../../../models/setting'
import { Tenant } from '../../../../models/tenant'
import { setSettings } from '../../../settings/settingsSlice'
import {
  selectSettings,
  selectTenant,
  selectAutoCreateFeeVOList,
  saveSettingLabel,
  setIsChange,
  getSettingDetail,
  saveWarehouseSetupLabel,
} from '../../../user/setting/settingSlice'
import styles from '../../functionSettingTabs.module.css'
import { getPrintYJFYTemplateSettingList } from '../../../print/printSlice'
import { EditableList } from '../../../../compnents/list/EditableList'
import { EditDetailModal } from '../../../weChart/management/DoctorManagement/editDetailModal'
import { AddOrEditModal } from './addOrEditModal'
import { pageDurgsystem, selectDurgsystemData } from '../../../durgsystem/durgsystemSlice'
import { getRecipeNormalFrequencyName, SPLBCategoryCategories } from '../../../../models/warehouseSetup'

export const WarehouseSetup = (props: { selectedTab?: any }): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const { Option } = Select

  const [salculateSalePriceNum, setSalculateSalePriceNum] = useState<any>(25)

  const [salculateSalePrice, setSalculateSalePrice] = useState<any>(false)

  const [buttonLoading, setButtonLoading] = useState(false)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const settings = useSelector(selectSettings)

  const tenant = useSelector(selectTenant)

  const durgData = useSelector(selectDurgsystemData)

  const [zdpdDay, setZdpdDay] = useState<any>()

  const [printFlag, setPrintFlag] = useState<any>(false)

  const [zdpdFlag, setZdpdFlag] = useState<any>(false)

  const [templateList, setTemplateList] = useState<any>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [title, setTitle] = useState('create')

  const [selectIndex, setSelectIndex] = useState<any>()

  const [selectEditMessage, setSelectEditMessage] = useState<any>()

  const [page, setPage] = useState({
    items: [] as any,
    total: 0,
    size: 100,
    current: 1,
  })

  const [submitList, setSubmitList] = useState([] as any)

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  useEffect(() => {
    if (props?.selectedTab == '5') {
      dispatch(pageDurgsystem(1, 100, 1))
      if (tenant) {
        form.setFieldsValue({
          ...tenant,
          registeredFund: null,
        })
      }
      if (settings) {
        const defaultMethod =
          (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
        dispatch(
          setSettings({
            [Settings.Treatment.DoNotWarnDoctorMismatch]:
              settings[Checks.Gbkdysstx] || false,
            [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
            [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
            [Settings.Payment.DefautMethod]: defaultMethod,
            [Settings.Recipe.AutoChangePrice]: settings[Checks.ZDJSTS] || false,
            [Settings.Recipe.AutoChangePriceAfter]:
              settings[Checks.ZDJSTSBCH] || false,
          })
        )
        // 一键发药后自动打印
        const YJFYHZDDYValue = settings[Checks.YJFYHZDDY]
        const templateListIds = templateList?.map((v: any) => v?.templateId)
        //模板id
        const YJFYHZDDYValueId = YJFYHZDDYValue ? YJFYHZDDYValue?.split(',') : []
        //筛选下拉框中包含模板id的选项
        const existingNumbers = YJFYHZDDYValueId?.length
          ? YJFYHZDDYValueId?.filter((num: any) =>
            templateListIds?.includes(num)
          )
          : YJFYHZDDYValueId

        //自动盘点周期
        const ZDPDZQValue = settings[Checks.ZDPDZQ] ? settings[Checks.ZDPDZQ] : ''
        //自动盘点库房
        const ZDPDKFValue = settings[Checks.ZDPDKF]
        const durgDataListIds = durgData?.map((v: any) => v?.id)
        //库房id
        const ZDPDKFValueId = ZDPDKFValue ? ZDPDKFValue?.split(',')?.map((v: any) => (Number(v))) : []
        //筛选下拉框中包含库房id的选项
        const existingZDPDKFNumbers = ZDPDKFValueId?.length
          ? ZDPDKFValueId?.filter((num: any) =>
            durgDataListIds?.includes(Number(num))
          )
          : ZDPDKFValue?.split(',')

        form.setFieldsValue({
          ...settings,
          [Checks.KFZDHTBZZCF]: settings[Checks.KFZDHTBZZCF]?.toString() || 'true',
          [Checks.RKDJHT]: settings[Checks.RKDJHT]?.toString() || '1',
          [Checks.LSDJHT]: settings[Checks.LSDJHT]?.toString() || '1',
          [Checks.FYFS]: settings[Checks.FYFS] ? settings[Checks.FYFS]?.toString() : '1',
          //一键发药后自动打印回填
          [Checks.YJFYHZDDY]: existingNumbers
            ? existingNumbers
            : [],
          // 自动盘点库房
          [Checks.ZDPDKF]: existingZDPDKFNumbers ? existingZDPDKFNumbers : [],
          // 自动盘点周期
          [Checks.ZDPDZQ]: ZDPDZQValue ? (ZDPDZQValue != 'month' && ZDPDZQValue != 'quarter' ? 'day' : ZDPDZQValue) : 'quarter',
        })
        // 自动计算售价默认值
        const ZDJSSJ =
          settings[Checks.ZDJSSJ] == -1 ? 25 : settings[Checks.ZDJSSJ]
        // 一键发药后自动打印开启关闭的状态
        setPrintFlag(YJFYHZDDYValue ? true : false)
        // 自动计算售价开启关闭的状态
        setSalculateSalePrice(settings[Checks.ZDJSSJ] != -1 ? true : false)
        // 自动计算售价的利润值
        setSalculateSalePriceNum(ZDJSSJ)
        // 自动盘点库房开启关闭的状态
        setZdpdFlag(ZDPDZQValue ? true : false)
        // 自动盘点周期
        setZdpdDay(ZDPDZQValue ? ZDPDZQValue != 'month' && ZDPDZQValue != 'quarter' ? Number(ZDPDZQValue) : '' : '',)

        // 回填库存默认下限值
        const list = SPLBCategoryCategories?.map((v, index) => {
          return {
            merchandiseCategories: v,
            windowsDefault: settings[v],
            indexId: index
          }
        })?.filter((v: any) => v?.windowsDefault != undefined)
        setPage({
          ...page,
          items: list
        })
        setSubmitList(list)
      }
    }
  }, [tenant, settings, props?.selectedTab])

  useEffect(() => {
    if (props?.selectedTab == '5') {
      dispatch(getSettingDetail())
      getPage()
    }
  }, [props?.selectedTab])

  const getPage = () => {
    dispatch(getPrintYJFYTemplateSettingList())
      .then(unwrapResult)
      .then((v: any) => {
        const data = v?.records?.map((i: any) => {
          return { ...i, templateId: i?.templateId?.toString() || i?.id?.toString() }
        })
        setTemplateList(data)
      })
  }
  return (
    <div className={styles.warehouseSetUp}>
      <>
        <Form
          style={{ height: '98%' }}
          form={form}
          autoComplete='off'
          initialValues={{
            [Checks.FYFS]: '1',
          }}
          onFinish={(values) => {
            const pattern = /^[0-9]*$/
            if (values[Checks.YJFYHZDDY]?.length > 10) {
              notification.info({
                message: '最多只能添加10个模板',
              })
              return
            }
            const t = _.chain(values)
              .omitBy((_, k) => pattern.test(k))
              .value() as Tenant
            const f = _.chain(values)
              .pickBy((_, k) => pattern.test(k))
              .mapValues(
                (v, k) =>
                ({
                  type: k,
                  value:
                    k === Checks.ZDJSSJ.toString()
                      ? (salculateSalePrice
                        ? salculateSalePriceNum
                        : '-1')
                      : k == Checks.YJFYHZDDY.toString() ? (printFlag ? v?.join(',') : '')
                        : k == Checks.ZDJSSJ.toString() ? (salculateSalePrice ? salculateSalePriceNum || 25 : 0)
                          : k == Checks.ZDPDZQ.toString() ? (v == 'day' ? zdpdDay : v)
                            : v?.toString(),
                } as Settinglable)
              )
              .values()
              .value()

            setButtonLoading(true)
            dispatch(
              saveWarehouseSetupLabel(
                [...f, ...submitList],
              )
            )
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '保存成功,部分配置需要重新登陆后生效',
                  duration: 3,
                })
                dispatch(getSettingDetail())
              })
              .catch(() => {
                notification.error({ message: '机构设置保存失败', duration: 3 })
                dispatch(getSettingDetail())
              })
              .finally(() => {
                dispatch(setIsChange(false))
                setButtonLoading(false)
              })
          }}
          onValuesChange={(values, all) => {
            dispatch(setIsChange(true))
          }}
        >
          <div style={{ overflow: 'auto', height: 'calc(100% - 25px)' }}>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              发药设置
            </Row>
            <div style={{ marginTop: '20px' }}>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='自动发药'
                  name={Checks.Zdfy}
                  valuePropName='checked'
                >
                  <Switch
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                  ></Switch>
                </Form.Item>
                <span className={styles.nameTips}>开启后，所有需要发药的处方都会自动发药</span>
              </Col>
              <Col className={styles.rowHeightRadio} span={24}>
                <Form.Item label='发药方式' name={Checks.FYFS}>
                  <Radio.Group>
                    <Radio value={'1'}>最小库存批次优先</Radio>
                    <Radio value={'2'}>近效期批次优先</Radio>
                    <Radio value={'3'}>
                      <span>最早入库批次优先(先入先出)</span>
                      <span className={styles.nameTips}>（按批次开方时按照发药顺序展示）</span>
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <div style={{ marginTop: '20px' }}>
                <Col className={styles.rowHeight} span={24}>
                  <Form.Item
                    label='一键发药后自动打印'
                    rules={[{ max: 256, message: '最大256位!' }]}
                  >
                    <Switch
                      checked={printFlag}
                      checkedChildren='开启'
                      unCheckedChildren='关闭'
                      onChange={(v) => {
                        setPrintFlag(v)
                      }}
                    />
                  </Form.Item>
                  <Col span={16} style={{ marginLeft: '10px' }}>
                    <Form.Item
                      name={Checks.YJFYHZDDY}
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <Select
                        placeholder="模板选择"
                        style={{ width: '70%' }}
                        className={styles.addtion}
                        mode='multiple'
                        showArrow
                        showSearch={false}
                      >
                        {templateList?.map((v: any) => (
                          <Option key={v?.templateId} value={v?.templateId}>
                            {v?.templateDesc}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Col>
              </div>
            </div>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              购入入库设置
            </Row>
            <div style={{ marginTop: '20px' }}>
              {/* <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  name={Checks.SJTB}
                  label='数据同步'
                  valuePropName='checked'
                >
                  <Switch
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                  ></Switch>
                </Form.Item>
                <span className={styles.nameTips}>
                  开启数据同步后，生产日期、有效期、批次号这三列内容会默认回填录入的第一个商品的内容
                </span>
              </Col> */}
              <Col className={styles.rowHeightRadio} span={24}>
                <Form.Item label='入库单价回填' name={Checks.RKDJHT}>
                  <Radio.Group>
                    <Radio value={'0'}>不回填</Radio>
                    <Radio value={'1'}>回填目录进价</Radio>
                    {/*<Radio value={'2'}>回填上一次入库的入库单价</Radio>*/}
                  </Radio.Group>
                </Form.Item>
                {/*<span className={styles.nameTips}>*/}
                {/*  （如没有入库过则回填目录进价）*/}
                {/*</span>*/}
              </Col>
              <Col className={styles.rowHeightRadio} span={24}>
                <Form.Item label='零售单价回填' name={Checks.LSDJHT}>
                  <Radio.Group>
                    <Radio value={'0'}>不回填</Radio>
                    <Radio value={'1'}>回填目录零售价</Radio>
                    {/*<Radio value={'2'}>回填上一次入库的零售单价</Radio>*/}
                  </Radio.Group>
                </Form.Item>
                {/*<span className={styles.nameTips}>*/}
                {/*  （如有调价过则回填调价后的单价）*/}
                {/*</span>*/}
              </Col>
              {/* <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='自动计算售价'
                  valuePropName='checked'
                >
                  <Switch
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                    checked={salculateSalePrice}
                    onChange={(v) => {
                      setSalculateSalePrice(v)
                      setSalculateSalePriceNum(salculateSalePriceNum || 25)
                    }}
                  />
                </Form.Item>
                {salculateSalePrice ? (
                  <>
                    <div
                      style={{
                        height: '32px',
                        lineHeight: '32px',
                        margin: '0 10px',
                      }}
                    >
                      根据
                    </div>
                    <Form.Item label='' name={Checks.ZDJSSJ}>
                      <Input
                        value={salculateSalePriceNum}
                        defaultValue={25}
                        style={{ width: '80px' }}
                        width={150}
                        onChange={(v) => {
                          const reg = new RegExp(
                            new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/)
                          )
                          if (Number(v.target.value) > 1000) {
                            notification.info({
                              message:
                                '值的范围在 1 ~ 1000 ，最多两位小数，请正确输入',
                            })
                          } else {
                            if (reg.test(v.target.value)) {
                              setSalculateSalePriceNum(v.target.value)
                            } else {
                              notification.info({
                                message:
                                  '值的范围在 1 ~ 1000 ，最多两位小数，请正确输入',
                              })
                            }
                          }
                        }}
                      />
                    </Form.Item>
                    <div
                      style={{
                        height: '32px',
                        lineHeight: '32px',
                        marginLeft: '10px',
                      }}
                    >
                      %利润计算售价
                    </div>
                  </>
                ) : (
                  ''
                )}
              </Col> */}
            </div>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              库存设置
            </Row>
            <div style={{ marginTop: '20px' }}>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='库存默认下限值'
                >
                  <Button
                    type='primary'
                    onClick={() => {
                      setIsModalVisible(true)
                      setTitle('create')
                      setSelectEditMessage({})
                    }}
                  >
                    新增
                  </Button>
                </Form.Item>
                <span className={styles.nameTips}>
                  设置后，原先没有设置过的商品的库存下限值都会回填这个值，已经设置过的则不会改变
                </span>
              </Col>
              <Col
                className={styles.rowHeight}
                span={23}
                style={{ marginLeft: '150px', width: '80%' }}
              >
                <EditableList
                  page={page}
                  bordered
                  pagination={false}
                  columns={[
                    {
                      title: '序号',
                      key: 'order',
                      align: 'center',
                      width: '2rem',
                      render: (_1, _2, index) => `${index + 1}`,
                    },
                    {
                      title: '商品类别',
                      dataIndex: 'merchandiseCategories',
                      width: '4rem',
                      align: 'center',
                      render: (_, t: any) => {
                        return (
                          t?.merchandiseCategories ? getRecipeNormalFrequencyName(t?.merchandiseCategories) : '-'
                        )
                      },
                    },
                    {
                      title: '默认值',
                      dataIndex: 'windowsDefault',
                      width: '4rem',
                      align: 'center',
                      render: (_, t: any) => {
                        return (
                          t?.windowsDefault ? t?.windowsDefault : '-'
                        )
                      },
                    },

                    {
                      title: '操作',
                      key: 'actions',
                      width: '4rem',
                      align: 'center',
                      render: function UserSettings(
                        _,
                        u: any,
                        index
                      ): ReactElement {
                        return (
                          <Space>
                            <a
                              onClick={() => {
                                setIsModalVisible(true)
                                setSelectIndex(u?.indexId)
                                setTitle('edit')
                                setSelectEditMessage(u)
                              }}
                            >
                              编辑
                            </a>
                            {/* <a
                              onClick={() => {
                                const list = [...page.items]
                                list.splice(index, 1)
                                setPage({
                                  ...page,
                                  items: list,
                                })
                              }}
                            >
                              删除
                            </a> */}
                          </Space>
                        )
                      },
                    },
                  ]}
                />
              </Col>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='默认自动清斗数量'
                  name={Checks.MEZDQDSL}
                >
                  <Input
                    style={{ margin: '0 0 0 8px', width: '130px' }}
                  />
                </Form.Item>
                <span className={styles.nameTips}>
                  只作用于中药材/饮片，设置后，原先没有设置过的中药材/饮片的自动清斗数量都会回填这个值，已经设置过的则不会改变
                </span>
              </Col>
            </div>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              盘点设置
            </Row>
            <div style={{ marginTop: '20px' }}>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='自动盘点'
                  valuePropName='checked'
                >
                  <Switch
                    checked={zdpdFlag}
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                    onChange={(v) => {
                      setZdpdFlag(v)
                    }}
                  ></Switch>
                </Form.Item>
                <span className={styles.nameTips}>
                  开启后，库存盘点里当前周期结束时会自动生成当前周期的盘点单
                </span>
              </Col>
              {zdpdFlag ? (
                <>
                  <Col className={styles.rowHeightRadio} span={24}>
                    <Form.Item label='自动盘点周期' name={Checks.ZDPDZQ}>
                      <Radio.Group>
                        <Radio value={'month'}>每月</Radio>
                        <Radio value={'quarter'}>每季度</Radio>
                        <Radio value={'day'}>每<Input style={{ width: '50px', margin: '0 10px' }} value={zdpdDay} onChange={(e) => setZdpdDay(e.target.value)} />天</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col className={styles.rowHeight} span={24}>
                    <Form.Item
                      label='自动盘点库房'
                      name={Checks.ZDPDKF}
                    >
                      <Select
                        placeholder='库房列表'
                        allowClear
                        mode='multiple'
                        style={{ width: '400px' }}
                        showSearch={false}
                      >
                        {durgData.map((v: any) => {
                          return (
                            <Option value={(v.id)} key={v.id}>
                              {v.name}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </>
              ) : null}
            </div>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              商品目录/诊疗目录设置
            </Row>
            <div style={{ marginTop: '20px' }}>   <Col className={styles.rowHeightRadio} span={24}>
              <Form.Item label='开方时备注回填' name={Checks.KFZDHTBZZCF} >
                <Radio.Group>
                  <Radio value={'false'}>不回填到医嘱处方</Radio>
                  <Radio value={'true'}>回填到医嘱处方</Radio>
                </Radio.Group>
              </Form.Item>
            </Col></div>
          </div>
          <Row>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => {
                  history.go(-1)
                }}
                style={{
                  float: 'right',
                  marginRight: '10px',
                }}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{
                  float: 'left',
                }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
      </>
      <AddOrEditModal
        pageList={page?.items}
        visible={isModalVisible}
        maskClosable={false}
        onCancel={() => {
          setIsModalVisible(false)
        }}
        title={title}
        editDetailMessage={selectEditMessage}
        onSuccess={(m: any) => {
          if (title == 'create') {
            const newItems = page?.items?.length
              ? [...page.items, m]
              : [m]

            // 按 merchandiseCategories 从小到大排序
            const sortedItems = newItems
              .map((v: any, index: any) => ({ ...v, indexId: index }))
              .sort((a: any, b: any) => a.indexId - b.indexId)

            const data = { ...page, items: sortedItems }
            setPage(data)

            const submitList = data.items.map((v: any) => ({
              type: v.merchandiseCategories.toString(),
              value: Number(v.windowsDefault),
            }))
            setSubmitList(submitList)
          } else {
            const newItems = page?.items?.map((val: any, index?: any) => {
              return {
                ...val,
                merchandiseCategories:
                  index == selectIndex ? m?.merchandiseCategories : val?.merchandiseCategories,
                windowsDefault: index == selectIndex ? m?.windowsDefault : val?.windowsDefault,
              }
            })
            const sortedItems = newItems
              .map((v: any, index: any) => ({ ...v, indexId: index }))
              .sort((a: any, b: any) => a.indexId - b.indexId)

            const allDataList = {
              ...page,
              items: sortedItems,
            }
            setPage(allDataList)

            const submitList = sortedItems
              ?.map((v: any) => ({
                type: (v?.merchandiseCategories)?.toString(),
                value: Number(v.windowsDefault),
              }))
            setSubmitList(submitList)
          }

          setIsModalVisible(false)
        }}
      />
    </div>
  )
}
